module.exports = __webpack_public_path__ + "media/images/illust/post-bg-f1d1749e327e775aa59d6ec34005237e.jpg";